import SearchIcon from '../../icons/SearchIcon';
import SearchModal from '../SearchModal/SearchModal';
import { SearchNavWrapper, SearchButton, StyledSRText } from './SearchNavButton.styles';
import useModal from '@/components/Modal/hooks/useModal';

const SearchNavButton = () => {
  const { open } = useModal();
  const modalID = 'modal-search';
  return (
    <SearchNavWrapper>
      <SearchButton onClick={() => open(modalID)}>
        <SearchIcon />
        <StyledSRText>Search modal toggle button</StyledSRText>
      </SearchButton>
      <SearchModal modalID={modalID} />
    </SearchNavWrapper>
  );
};

export default SearchNavButton;
